import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-lg text-neutral-800" }, "Print Transaksi BBM", -1)
const _hoisted_2 = { class: "content px-4 mb-4" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-1 required" }, "Tanggal Mulai", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-red-500 text-xs mt-1 block"
}
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-semibold text-neutral-700 mb-1 required" }, "Tanggal Akhir", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 text-xs mt-1 block"
}
const _hoisted_9 = { class: "p-4 flex items-center justify-end gap-3 border-top-grey-3" }

import { ref, reactive, getCurrentInstance } from 'vue'
import Dialog from 'primevue/dialog'
import Calendar from 'primevue/calendar'
import Button from 'primevue/button'
import moment from 'moment'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrintReportDialog',
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:visible"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void
}), expose: any, slots: any, attrs: any }) {





const store = useStore()
const app = getCurrentInstance()
const { $toast } = (app?.appContext.config.globalProperties || {}) as any

const startDate = ref<any>()
const endDate = ref<any>()
const isLoading = ref(false)

const validationErrors = reactive({
  startDate: '',
  endDate: ''
})

const resetForm = () => {
  startDate.value = undefined
  endDate.value = undefined
  validationErrors.startDate = ''
  validationErrors.endDate = ''
}

const closeDialog = () => {
  resetForm()
  emit('update:visible', false)
}

const validate = (): boolean => {
  validationErrors.startDate = ''
  validationErrors.endDate = ''
  let isValid = true

  if (!startDate.value) {
    validationErrors.startDate = 'Tanggal mulai harus dipilih'
    isValid = false
  }

  if (!endDate.value) {
    validationErrors.endDate = 'Tanggal akhir harus dipilih'
    isValid = false
  }

  if (startDate.value && endDate.value) {
    const isAfter = moment(startDate.value).isAfter(moment(endDate.value), 'day')
    if (isAfter) {
      validationErrors.startDate = 'Tanggal mulai tidak boleh melebihi tanggal akhir'
      isValid = false
    }
  }

  return isValid
}

const handleGenerateReport = async () => {
  if (!validate()) {
    return
  }

  const startDateFormatted = moment(startDate.value).format('DD-MM-YYYY')
  const endDateFormatted = moment(endDate.value).format('DD-MM-YYYY')
  const fileName = `Laporan Pom ${startDateFormatted}-${endDateFormatted}`

  // Buka tab baru secara sinkron dengan user click agar tidak diblokir oleh popup blocker
  const newTab = window.open('about:blank', '_blank')
  if (newTab) {
    try {
      newTab.document.title = `Memuat ${fileName}...`
      newTab.document.body.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:Nunito Sans,sans-serif;color:#64748b;background:#f8fafc;">
          <div style="text-align:center;">
            <p style="font-size:16px;font-weight:600;margin-bottom:8px;">Sedang menyiapkan dokumen...</p>
            <p style="font-size:13px;color:#94a3b8;">${fileName}</p>
          </div>
        </div>
      `
    } catch (e) {
      // ignore restriction if any
    }
  }

  const payload = {
    StartDate: moment(startDate.value).format('YYYY-MM-DD'),
    EndDate: moment(endDate.value).format('YYYY-MM-DD')
  }

  try {
    isLoading.value = true
    store.dispatch('showLoading')

    const response = await apiUseCase.postBlob(
      '/transaction/v2/FuelingPaymentBatches/GenerateReport',
      payload
    )

    const { error, result, message } = response

    if (!error && result) {
      const file = new File([result], `${fileName}.pdf`, { type: 'application/pdf' })
      const fileUrl = window.URL.createObjectURL(file)

      if (newTab && !newTab.closed) {
        try {
          newTab.document.title = fileName
          newTab.document.body.style.margin = '0'
          newTab.document.body.style.padding = '0'
          newTab.document.body.style.height = '100vh'
          newTab.document.body.style.overflow = 'hidden'
          newTab.document.body.style.display = 'flex'
          newTab.document.body.style.flexDirection = 'column'
          newTab.document.body.style.background = '#252F40'

          const topBar = newTab.document.createElement('div')
          topBar.style.cssText = 'display:flex;justify-content:space-between;align-items:center;background:#252F40;color:#fff;padding:10px 20px;font-family:Nunito Sans,sans-serif;font-size:14px;box-shadow:0 2px 6px rgba(0,0,0,0.25);z-index:10;'

          const titleSpan = newTab.document.createElement('span')
          titleSpan.textContent = `${fileName}.pdf`
          titleSpan.style.cssText = 'font-weight:700;letter-spacing:0.3px;color:#ffffff;'

          const btnDownload = newTab.document.createElement('button')
          btnDownload.textContent = 'Download PDF'
          btnDownload.style.cssText = 'background:#4791FC;color:#fff;border:none;padding:7px 16px;border-radius:6px;cursor:pointer;font-weight:700;font-size:13px;transition:background 0.2s;'
          btnDownload.onmouseover = () => { btnDownload.style.background = '#327ae0' }
          btnDownload.onmouseout = () => { btnDownload.style.background = '#4791FC' }
          btnDownload.onclick = () => {
            const a = newTab.document.createElement('a')
            a.href = fileUrl
            a.download = `${fileName}.pdf`
            newTab.document.body.appendChild(a)
            a.click()
            a.remove()
          }

          topBar.appendChild(titleSpan)
          topBar.appendChild(btnDownload)
          newTab.document.body.innerHTML = ''
          newTab.document.body.appendChild(topBar)

          const iframe = newTab.document.createElement('iframe')
          iframe.src = fileUrl
          iframe.style.cssText = 'flex:1;width:100%;height:calc(100vh - 48px);border:none;'
          newTab.document.body.appendChild(iframe)

          newTab.addEventListener('keydown', (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
              e.preventDefault()
              btnDownload.click()
            }
          })
        } catch (e) {
          newTab.location.href = fileUrl
        }
      } else {
        window.open(fileUrl, '_blank')
      }

      $toast.add({
        severity: 'success',
        detail: 'Laporan berhasil dibuat',
        group: 'bc',
        life: 3000
      })

      closeDialog()
    } else {
      if (newTab && !newTab.closed) {
        newTab.close()
      }
      $toast.add({
        severity: 'error',
        detail: message || 'Gagal mencetak laporan transaksi',
        group: 'bc',
        life: 3000
      })
    }
  } catch (err: any) {
    if (newTab && !newTab.closed) {
      newTab.close()
    }
    $toast.add({
      severity: 'error',
      detail: err?.message || 'Terjadi kesalahan saat memproses laporan',
      group: 'bc',
      life: 3000
    })
  } finally {
    isLoading.value = false
    store.dispatch('hideLoading')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    showHeader: false,
    visible: __props.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    breakpoints: { '960px': '75vw', '640px': '90vw' },
    style: { width: '450px' },
    modal: true,
    contentClass: "wrap-content-hjp-confirm-modal"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "p-4 flex items-center justify-between border-bottom-grey-3 mb-4" }, [
        _hoisted_1,
        _createElementVNode("i", {
          class: "pi pi-times cursor-pointer text-neutral-400 hover:text-neutral-600 text-lg",
          onClick: closeDialog
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(Calendar), {
            modelValue: startDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
            dateFormat: "dd/mm/yy",
            showIcon: true,
            placeholder: "Pilih tanggal mulai",
            class: "w-full",
            maxDate: endDate.value
          }, null, 8, ["modelValue", "maxDate"]),
          (validationErrors.startDate)
            ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(validationErrors.startDate), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(Calendar), {
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
            dateFormat: "dd/mm/yy",
            showIcon: true,
            placeholder: "Pilih tanggal akhir",
            class: "w-full",
            minDate: startDate.value
          }, null, 8, ["modelValue", "minDate"]),
          (validationErrors.endDate)
            ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(validationErrors.endDate), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Button), {
          label: "Batal",
          class: "btn-back !px-4 !py-2 text-sm",
          disabled: isLoading.value,
          onClick: closeDialog
        }, null, 8, ["disabled"]),
        _createVNode(_unref(Button), {
          type: "button",
          label: "Cetak",
          icon: "pi pi-print",
          class: "btn-primary !px-4 !py-2 text-sm flex items-center gap-2",
          loading: isLoading.value,
          onClick: handleGenerateReport
        }, null, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})